import { inject } from '@angular/core';
import { Router, type ResolveFn } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { StorageEnum } from '../enums/storage.enum';
import { UtilService } from '../services/util.service';
import { AccountDetail } from '../models/account-detail';
// import { Nav } from '../enums/nav.enum';
import { concatMap, from, map, of } from 'rxjs';
import { AccountService } from '../services/account.service';
import { type UserProfile } from '../models/user-profile';
import { PaymentService } from '../services/payment.service';
import { AlertsService } from '../services/alerts.service';
import { BiometricsService } from '../services/biometrics.service';
import { environment } from '../../../environments/environment';

export const multiAccountResolver: ResolveFn<any> = (route, state) => {
  const storage = inject(StorageService);
  const accountS = inject(AccountService);
  const paymentS = inject(PaymentService);
  const alertsS = inject(AlertsService);
  const bioS = inject(BiometricsService);
  const utils = inject(UtilService);
  const router = inject(Router);
  const multiAccount = storage.getSession(StorageEnum.MultiAccountResponse);

  if (!multiAccount) {
    utils.consoleLog('multiAccountResolver: Not multi account');
    return true;
  } else {
    utils.consoleLog('multiAccountResolver: multi account');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const routerState = router.currentNavigation()!.extras.state!;
    const accountNumber = routerState
      ? // eslint-disable-next-line @typescript-eslint/dot-notation
        routerState['accountNumber']
      : storage.getSession(StorageEnum.LoginResponse)?.AccountNumber;
    let accountDetail = new AccountDetail();

    const copyMulti: UserProfile = JSON.parse(JSON.stringify(multiAccount));
    const account = multiAccount.Accounts.find((acc: any) => {
      return acc.AccountNumber === accountNumber;
    });
    if (account) {
      copyMulti.Accounts = [account];
      storage.setSession(StorageEnum.LoginResponse, copyMulti);
      environment.AuthToken = copyMulti.AuthToken ?? '';

      const acct: any = copyMulti;
      const accountNumber = acct.Accounts[0].AccountNumber;

      return accountS.getAccountDetail(accountNumber, acct.UserName ?? '').pipe(
        concatMap((data: AccountDetail) => {
          accountDetail = data;
          return paymentS.GetFuturePayment(accountNumber);
        }),
        concatMap((data: any) => {
          accountDetail.FuturePayment = data;
          if (acct.Accounts[0].ServiceAddresses[0].SaStatusFlag === '10') {
            // if SaStatusCode = Pending Start - set headline to 10 = Pending Start,
            return of('10');
          } else {
            return accountS.GetHeadlineCode(accountNumber);
          }
        }),
        concatMap((data: string) => {
          accountDetail.HeadlineCode = data.toString();
          if (accountDetail.IsAutoPay) {
            return accountS.GetAutoPayDetails(accountNumber);
          } else {
            return of('no autopay');
          }
        }),
        concatMap((data: any) => {
          if (data !== 'no autopay') {
            accountDetail.AutoPay = data;
          }

          if (accountDetail.IsPayPlan) {
            return accountS.GetPayPlanDetails(accountNumber);
          } else {
            return 'no payplan';
          }
        }),
        concatMap((data: any) => {
          if (data !== 'no payplan') {
            accountDetail.PayPlanAmount = data.PayPlanAmount;
            accountDetail.PayPlanDueDate = data.PayPlanDueDate;
            accountDetail.PayPlanType = data.PayPlanType;
            accountDetail.PaymentPlans = data.PaymentPlans;
          }
          const personReq = {
            AccountNumber: accountNumber,
            UserName: accountDetail.PrimaryAccountHolder === true ? acct.UserName : '',
            PersonId: acct.PersonId,
          };
          return accountS.GetPerson(personReq);
        }),
        map((personData: any) => {
          personData.FirstName = accountDetail.FirstName;
          personData.LastName = accountDetail.LastName;
          accountDetail.Person = personData;
          storage.setSession(StorageEnum.AccountDetail, accountDetail);
          utils.updateNav.set(true);
        }),
        // Request push notification permission after account selection (account info now available)
        concatMap(() => {
          if (bioS.bioInfo.Platform === 'ios' || bioS.bioInfo.Platform === 'android') {
            return from(
              alertsS.GetDeviceToken().catch((error) => {
                utils.consoleGroup('Error requesting push permission in resolver:', error);
                // Continue even if push permission fails
              }),
            );
          }
          return of(undefined);
        }),
      );
    } else {
      utils.consoleLog('multiAccountResolver: multi account fail');
      return false;
    }
  }
};
